import { AxiosError } from 'axios';
import { useQuery, useQueryClient } from 'react-query';
import { map as _map, filter as _filter, } from 'lodash';

import { fetchBanners } from '../api';
import { QueryKeys, Banner } from '../types';

export interface UseBannersProps {
  baseUrl: string
  locale: string
}

export const useBanners = ({ baseUrl, locale }: UseBannersProps) => {
  const queryClient = useQueryClient();
  return useQuery<Banner[], AxiosError>([QueryKeys.Banners], () => fetchBanners(baseUrl), {
    staleTime: 60 * 1000,
    retry: false,
    select: (data) => {
      const isErrored = data[0]?.isErrored;
      const filtered = _filter(data, { locale });
      const banners = _map(filtered, banner => {
        if (banner?.content?.images !== []) {

            const images = banner.content.images;

            const addUrl = function(images: { [x: string]: { url: string; }; }) {
              Object.keys(images).forEach(function(key){ 
                if(!images[key].url.includes(baseUrl)){
                  const imagesUrl = images[key].url.startsWith('/') ? images[key].url.substr(1) : images[key].url;
                  images[key].url = `${baseUrl}${imagesUrl}`
                }
              });
              return images;
            }

            const newCollection = addUrl(images);
            
            return {...banner, content: { ...banner.content, images: newCollection }};
        }
        
        return banner;
      });

      return isErrored ? filtered : banners;
    },
    onError: async () => {
      try {
        const data = await fetchBanners(``);
        
        queryClient.setQueryData([QueryKeys.Banners], [ { isErrored: true }, ...data ]);
      } catch (error) {
        // Log the error with Sentry, the fallback failed.
      }
    }
  })
}